import React from 'react'
import PrintIcon from './../../assets/PrintIcon'
import DownloadIcon from './../../assets/DownloadIcon'
import { useGeneratePDF } from '../../common/hooks/useGeneratePDF'

function PrintAndDownloadButton({ onAction, invoiceData }) {
  const { isPrinting, isDownloading } = useGeneratePDF()

  return (
    <div className="actionButton mt-5 dFlex fdColumn ai-flex-end">
      <div className="download-print-button-group">
        <button
          className="download-print-button print"
          onClick={() => onAction('PRINT', invoiceData)}
          disabled={isDownloading || isPrinting}
        >
          <PrintIcon />
          <span className="printButtonMargin">Print</span>
        </button>

        <button
          className="download-print-button download"
          onClick={() => onAction('DOWNLOAD', invoiceData)}
          disabled={isDownloading || isPrinting}
        >
          <DownloadIcon />
          <span className="downloadButtonMargin">Download</span>
        </button>
      </div>
    </div>
  )
}

export default PrintAndDownloadButton
